(function () {
  var modal = document.querySelector('[data-ai-calculator-modal]');
  var frame = document.getElementById('ai-calculator-frame');
  if (!modal || !frame) return;

  var config = window.AICalculatorConfig || {};
  var baseUrl = (config.endpoint || 'https://ai-calculator.ever-pretty.com').replace(/\/$/, '');
  var endpointOrigin;
  try { endpointOrigin = new URL(baseUrl).origin; } catch (error) { endpointOrigin = ''; }
  var activeSource = 'header';

  function postToCalculator(message) {
    if (frame.contentWindow) frame.contentWindow.postMessage(message, endpointOrigin || '*');
  }

  function currentCart() {
    return fetch('/cart.js').then(function (response) {
      if (!response.ok) throw new Error('Unable to load cart');
      return response.json();
    }).then(function (cart) {
      return (cart.items || []).map(function (item) {
        return {
          variantId: String(item.variant_id), title: item.product_title, variantTitle: item.variant_title,
          sku: item.sku, quantity: item.quantity, price: Number(item.final_price || item.price || 0) / 100,
          currency: cart.currency || config.currency || 'USD', shippingWeightKg: Number(item.grams || 0) / 1000,
        };
      });
    });
  }

  // The base logistics cost comes from the TMS interface, so the theme no longer
  // reads Shopify storefront shipping rates.
  function sendContext() {
    var shouldUseCart = activeSource === 'mini-cart' || activeSource === 'cart';
    (shouldUseCart ? currentCart() : Promise.resolve([])).then(function (lines) {
      postToCalculator({ type: 'ai-calculator-context', source: activeSource, userId: config.userId || 'anonymous', lines: lines });
    }).catch(function () {
      postToCalculator({ type: 'ai-calculator-context', source: activeSource, userId: config.userId || 'anonymous', lines: [] });
    });
  }

  function open(source) {
    activeSource = source || 'header';
    modal.hidden = false;
    document.documentElement.classList.add('ai-calculator-open');
    frame.src = baseUrl + '/calculator?source=' + encodeURIComponent(activeSource);
    frame.onload = sendContext;
  }

  // Tell the calculator the window is closing so it can record the estimate in the
  // backend before the iframe is hidden.
  function close() {
    postToCalculator({ type: 'ai-calculator-close' });
    modal.hidden = true;
    document.documentElement.classList.remove('ai-calculator-open');
  }

  // The mini-cart is replaced by Shopify section rendering after cart updates.
  // Delegate the trigger event from document so newly rendered buttons keep working.
  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-ai-calculator-open]') : null;
    if (button) {
      event.preventDefault();
      open(button.getAttribute('data-ai-calculator-source') || 'header');
      return;
    }
    if (event.target.closest && event.target.closest('[data-ai-calculator-close]')) close();
  });
  modal.querySelectorAll('[data-ai-calculator-close]').forEach(function (button) { button.addEventListener('click', close); });
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && !modal.hidden) close(); });
}());
